import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AuthState = {
  authToken: string | null;
  isAuth: boolean;
  loading: boolean;
  error: boolean;
  user: {
    username?: string;
    authorized?: boolean;
  };
};

const initialState: AuthState = {
  authToken: localStorage.getItem("authToken"),
  isAuth: false,
  loading: localStorage.getItem("authToken") ? true : false,
  error: false,
  user: {
    username: "",
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loading: (state) => {
      state.loading = true;
    },
    signIn: (
      state,
      action: PayloadAction<{
        username: string;
        token?: string;
        authorized?: boolean;
      }>
    ) => {
      action.payload?.token &&
        localStorage.setItem("authToken", action.payload.token);

      state.isAuth = true;
      state.loading = false;
      state.error = false;
      state.user.username = action.payload.username;
      state.user.authorized = action.payload?.authorized;
    },
    signOut: (state) => {
      localStorage.removeItem("authToken");
      state.isAuth = false;
      state.loading = false;
      state.error = false;
      state.user = {};
    },
    setError: (state) => {
      state.isAuth = false;
      state.loading = false;
      state.error = true;
    },
    removeError: (state) => {
      state.error = false;
    },
  },
});

export const { loading, signIn, signOut, setError, removeError } =
  authSlice.actions;

export default authSlice.reducer;
